import axios from 'axios'

import timeoutPromise from '@function/ajax/timeoutPromise'
import getTimeout     from '@function/ajax/getTimeout'
import getErrors      from '@function/ajax/getErrors'

const DEFAULT_ERR = 'Connexion impossible pour le moment, ' +
	'veuillez vérifier votre connexion ou réessayez ultérieurement.';

export default async function ajaxRequest (url, options={ })
{
	const { min_duration=440 } = options;

	let req_time = new Date();

	const headers = { };

	if (options.files === true)
	{
		headers['Content-Type'] = 'multipart/form-data';
	}

	let completed = false;

	const timeout = ((options || { }).axios_params || { }).timeout > 0
	? options.axios_params.timeout
	: options.files ? 120 * 1000 : undefined;

	try
	{
		const cancel_token = options.axios_token || axios.CancelToken.source();

		timeoutPromise(timeout).then(function ()
		{
			if (completed === false) cancel_token.cancel();
		});

		const config =
		{
			headers: headers,
			cancelToken: cancel_token.token
		};

		if (typeof options.withCredentials === 'undefined')
		{
			config.withCredentials = true;
		}

		if (options.axios_params) Object.assign(config, options.axios_params);

		if (timeout) config.timeout = timeout;

		const { data: response } = await axios.post(url, options.data, config);

		completed = true;

		return new Promise(function (resolve)
		{
			setTimeout(() => resolve(response), getTimeout(req_time, min_duration));
		});
	}
	catch (e)
	{
		completed = true;

		if (!e.response?.data) console.error(e);

		const update =
		{
			...getErrors(
			{
				response: e.response?.data
				? e.response.data
				: undefined,

				error: e.response?.data?.error || DEFAULT_ERR
			})
		};

		if (e.response?.data?.errors)
		{
			update.errors = e.response?.data?.errors;
		}

		throw update;
	}
}